<template>
	<div class="create-patient bg-white">
		<div class="create-patient-base">
			<DoctorCard ref="doctorCard" />
			<Certification class="certification" :p-name.sync="params.name" :p-card.sync="params.cardNumber" />
			<patient-relation v-model="params.relation" />
		</div>
		<!-- <div class="create-patient-form">
			<form-list v-model="params" />
		</div> -->
		<foot-button>
			<div class="w-full" @click="clickSubmitRoot">
				<van-button
					type="primary"
					:loading="loading"
					loading-text="加载中.."
					block
					:disabled="!allowSubmit"
					@click="clickSubmit"
				>
					确认绑定
				</van-button>
			</div>
		</foot-button>
	</div>
</template>

<script>
import DoctorCard from './components/doctor-card.vue'
import Certification from './components/certification.vue'
import PatientRelation from "@/components/modules/patient-relation/patient-relation"


// import FormList from "./components/form-list.vue"
import { mapMutations } from 'vuex'
export default {
    name: 'create-patient',
    components: { PatientRelation, DoctorCard, Certification },
    data: () => ({
        loading: false,
        showTeamDetail: false,
        doctorDetail: {},
        teamDetail: {},
        params: {
            doctorId: '',
            cardNumber: '',
            name: '',
            relation: '',
            // diseaseDate: '',//发病日期
            // dischargeDate: '',//出院时间
            // height: '',
            // weight: '',
            // bmi: '',
            // smokingHistory: '',
            // drinkingHistory: '',
            // mainDiagnosis: '',
            // mainDiagnosisType: '',
            // diseaseHistoryList: []
        }
    }),
    mounted () {
        this.$refs.doctorCard.getDoctorDetail(this.$route.params.id)
        if (this.teamId) {
            this.getTeamDetail()
        }
    },
    computed: {
        allowSubmit () {
            if (!this.params.name.length) return false
            if (this.params.cardNumber.length !== 18) return false
            if (this.params.relation === '') return false
            return true
        },
        teamId () {
            return this.$route.params.teamId
        }
    },
    methods: {
        ...mapMutations('account', ['SET_PATIENT_ID']),
        clickSubmitRoot () {
            if (this.params.cardNumber === '' || this.params.name === '') {
                this.$toast('请将患者认证信息补充完成')
                return
            }
            if (this.params.relation === '') {
                this.$toast('请选择您与患者的关系')
                return
            }
        },
        async clickSubmit () {
            this.loading = true
            this.params.doctorId = this.$route.params.id
            this.params.teamId = this.teamId
            this.params.bindType = this.teamId ? 2 : 1
            const res = await this.$api.patient.savePatientBindDoctor(this.params)
            this.loading = false
            if (!res.code) {
                this.$toast('绑定成功')
                this.SET_PATIENT_ID(res.data)
                // 弹出弹窗
                this.$refs.doctorCard.showDialog()
                // await this.$router.push('/dpbind/result/success')
            }
        },
        /**
             * @method 获取团队详情
             * @param {string} id 
             */
        async getTeamDetail () {
            const { code, data } = await this.$api.doctor.getTeamDetail(this.teamId)
            if (!code) {
                this.teamDetail = data
                this.$refs.doctorCard.getTeamDetail(data)
            }
        },
    }
};
</script>

<style scoped lang="less">
.create-patient {
	min-height: calc(100vh - 216px);
	&-base {
		padding: 40px;
	}
	&-form {
		border-top: 10px solid #f5f6f7;
		margin-top: 16px;
		padding: 56px 40px 0;
	}

	.certification {
		margin-top: 80px;
		margin-bottom: 100px;
	}
}
</style>
